import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-logo">
          <h3 style={{ fontWeight: "300", letterSpacing: "2px" }}>
            Dr. Tayfun Giyik
          </h3>
          <p style={{ marginTop: "0.5rem", opacity: "0.8" }}>
            Medikal Estetik Uygulamaları
          </p>
        </div>

        <div className="social-links">
          <a
            href="https://www.instagram.com/dr.tayfungiyik/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
          >
            <FaTwitter />
          </a>
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <FaYoutube />
          </a>
        </div>

        <div className="copyright">
          <p>&copy; {currentYear} Dr. Tayfun Giyik. Tüm hakları saklıdır.</p>
          <p style={{ marginTop: "0.5rem", fontSize: "0.8rem" }}>
            Bu web sitesi tanıtım amaçlı hazırlanmıştır. Tıbbi tedavi önerisi
            yerine geçmez.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
